import { combineReducers } from "@reduxjs/toolkit";
import { chatReducer as chat } from "./modules/chat";
import { authReducer as auth } from "./modules/auth";

export const rootReducers = combineReducers({
  auth,
  chat,
});
